import { FirestoreCollections } from '@griply/types';
import { doc } from 'firebase/firestore';
import { UpdateTask } from 'shared/types/task';

import { dateToFirestoreTimestamp } from './converters/date-to-firestore-timestamp';
import { getCollection, updateDocWithTimestamp } from './helpers';

export const updateTask = (task: UpdateTask) => {
  const taskCollection = getCollection(FirestoreCollections.Tasks);
  const docRef = doc(taskCollection, task.id);
  updateDocWithTimestamp(docRef, dateToFirestoreTimestamp(task));
};
